// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__2ZYVK","infoBtn":"quickbooks_infoBtn__wWZ9v","formBox":"quickbooks_formBox__MwnIO","formFooter":"quickbooks_formFooter__1bsI8"};